"use strict";

var novicell = novicell || {};

novicell.navigation = novicell.navigation || new function () {
    var classOpened = "o-sidebar--opened";
    var classClosed = "o-sidebar--closed";
    var classShowDropDown = 'nav-main-list__link--showDropdown';
    var hoverIntentDelay = 300;
    this.init = function () {
        this.initSidebar();
        this.initMegamenu();
        this.initCloseMegaMenu();
    };
  
    this.removeAllHovers = function () {
        var navItemsWithDropdown = document.querySelectorAll('.o-navigations .nav-main-list__item--hasSublevel .nav-main-list__link');
        for(var i = 0 ; i < navItemsWithDropdown.length; i++){
            navItemsWithDropdown[i].classList.remove(classShowDropDown);
        }

        var openedAccordionsInside = document.querySelectorAll('.m-navDropdown__itemLevel1--hasSublevel.base-accordion--active .m-navDropdown__showHide');
        for(i = 0 ; i < openedAccordionsInside.length; i++){
            var elementToClick = openedAccordionsInside[i];
            var event = document.createEvent('HTMLEvents');
            event.initEvent('click', true, false);
            elementToClick.dispatchEvent(event);
        }
    };
    this.initCloseMegaMenu = function () {
        var _this = this;
        document.addEventListener("click",function(e) {
            if(novicell.helpers.closestByClass(e.target,'m-navDropdown') == null){
                _this.removeAllHovers();
            }
        });
    };
    this.initMegamenu = function () {
        var _this = this;
        var navItemsWithDropdown = document.querySelectorAll('.o-navigations .nav-main-list__item--hasSublevel .nav-main-list__link');
        if(navItemsWithDropdown.length){
            for(var i = 0 ; i < navItemsWithDropdown.length; i++){
                
                navItemsWithDropdown[i].addEventListener("touchstart",function(e) {
                    if (window.innerWidth >= 992) {
                        var link = this; //preselect the link
                        if (link.classList.contains(classShowDropDown)) {
                            return true;
                        } else {
                            _this.removeAllHovers();
                            link.classList.add(classShowDropDown);
                            e.preventDefault();
                            return false; //extra, and to make sure the function has consistent return points
                        }
                    }
                }, {passive: true});
                navItemsWithDropdown[i].parentNode.addEventListener("mouseenter",function(e) {
                    if (window.innerWidth >= 992) {
                        var _this = this;
                        this.classList.add('js-mouseenter');

                        setTimeout(function(){ 
                            if(_this.classList.contains('js-mouseenter')){
                                _this.querySelector('.a-link').classList.add(classShowDropDown);
                            }
                        }, hoverIntentDelay);
                    }
                });
                navItemsWithDropdown[i].parentNode.addEventListener("mouseleave",function(e) {
                    if (window.innerWidth >= 992) {
                        this.classList.remove('js-mouseenter');
                        var item = this;
                        setTimeout(function(){ 
                            if(!item.classList.contains('js-mouseenter')){
                                item.querySelector('.a-link').classList.remove(classShowDropDown);
                                _this.removeAllHovers();
                            }
                        }, hoverIntentDelay);
                    }
                });
            }
        }
        
    
    };
    this.initSidebar = function () {
        var oSidebar = document.getElementById("o-sidebar");
        if(oSidebar != null){
            var aSidebarCloseItem = document.getElementById("a-sidebar-close__item");
            if(aSidebarCloseItem != null){
                aSidebarCloseItem.addEventListener("click", function () {
                    oSidebar.classList.remove(classOpened);
                    oSidebar.classList.add(classClosed);
                });
            }
            
            var aLogoMenu = document.getElementById("a-logo__menu");
            if(aLogoMenu != null){
                aLogoMenu.addEventListener("click", function () {
                    if (!oSidebar.classList.contains(classOpened)) {
                        oSidebar.classList.add(classOpened);
                        oSidebar.classList.remove(classClosed);
                    } else {
                        oSidebar.classList.remove(classOpened);
                        oSidebar.classList.add(classClosed);
                    }
                });
            }
        }
    };
}();
